<template>
  <layout-component>
    <div class="banner banner-booking-success">
      <div class="container">
        <div class="row d-md-flex justify-content-md-center">
          <div class="col-md-8 col-lg-7 col-xl-6">
            <h1 class="left-bullet" v-html="$t('w.email-confirmed.title-banner')"></h1>
            <p>{{ 'w.email-confirmed.text-01'|t }}</p>

            <router-link class="btn mt-2 mt-md-3 mb-2 mb-md-0'" to="/book" active-class="active"><span>{{ 'w.email-confirmed.title-btn'|t }}</span></router-link>

          </div>
          </div>
      </div>
    </div>
	</layout-component>
</template>

<script>
    export default {
      mounted() {
        $('.title-anim-wrapper:in-viewport').addClass('in-viewport');
      }
    }
</script>
